<template>
  <v-app id="pageHelp">

<v-app-bar
    fixed
    clipped-left
    dark
    app
    dense
    color="primary"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <v-img 
          contain
          @click="toDashBoard"
          src="/static/logo-ligth-a.png" height="20" alt="Ecotrace"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      
  </v-app-bar>

    <v-content>
      <v-container>
        <h1 class="text-center">Manual do usuário</h1>
        <br>
        <v-expansion-panels focusable id="itens">
          <v-expansion-panel>
            <v-expansion-panel-header class="title">
                1. NOVO CADASTRO
            </v-expansion-panel-header>
            <v-expansion-panel-content id="step-1">
              <p class="subtitle-2">
                Passo 1.  Acessar o site no link abaixo
              </p>
              <p>
                <a href="https://web.ecotrace.solutions/login" target="_blank">https://web.ecotrace.solutions/login</a> 
                ou fazer o download do app Trace Beef na Google Play ou Apple store
              </p>
              <div class="container-qrcodes-store d-flex flex-row justify-center align-center">
                <div class="container-qrcode text-center">
                  <v-img src="/static/screens/login/qrcode_android.png"></v-img>

                  <v-btn class="btn-android" text @click="socialLinks('/apps/tracebeef?os=android', '_blank')">
                    <v-img src="/static/screens/login/android-download.png"></v-img>
                  </v-btn>
                </div>
                <div class="container-ou">
                  <span class="font-weight-black">OU</span>
                </div>
                <div class="container-qrcode text-center">
                  <v-img src="/static/screens/login/qrcode_ios.png"></v-img>

                  <v-btn class="btn-ios" text @click="socialLinks('/apps/tracebeef?os=ios', '_blank')">
                    <v-img src="/static/screens/login/ios-download.png"></v-img>
                  </v-btn>
                </div>
              </div>

              <p class="subtitle-2">
                Passo 2. Clicar em Cadastrar-se no Painel de Login
              </p>
              <v-img class="help-img"
                src="/static/screens/help/login-cadastro.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center center"
              />

              <p class="subtitle-2">
                Passo 3. Preencher os dados na tela do cadastro
              </p>
              <v-img class="help-img"
                src="/static/screens/help/cadastro-usuario.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center center"
              />
              <p class="subtitle-2">
                Passo 4. Após Preencher o cadastro, irá receber um código via SMS no celular para confirmação na tela abaixo.
              </p>
              <v-img class="help-img"
                src="/static/screens/help/confirmacao-sms.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center center"
              />
              <p class="subtitle-2">
                Passo 5. A última etapa para visualizar seus romaneios, você tem que clicar no botão CADASTRAR NOVA PROPRIEDADE
              </p>
              <v-img class="help-img"
                src="/static/screens/help/cadastro-propriedade.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>


          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              2. CADASTRO DA PROPRIEDADE
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="subtitle-2 mb-12">
                Passo 1. Cadastrar Nova Propriedade
              </p>
              
              <v-img class="help-img"
                src="/static/screens/help/propriedade-primeiros-passos.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
              <p class="subtitle-2 my-12">
                Passo 2. Ao preencher o cadastro da Propriedade, importante que o <span style="text-decoration: underline">CPF/CNPJ e Inscrição Estadual</span> sejam o mesmo que está na GTA
              </p>
              <v-img class="help-img"
                src="/static/screens/help/cadastro-propriedade-interna.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
              <p class="subtitle-2">
                Passo 3. Após o cadastro de propriedade com sucesso, você irá receber um e-mail de confirmação e pode usar o aplicativo 
              </p>
              <v-img class="help-img"
                src="/static/screens/help/cadastro-propriedade-concluido.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />

              <v-spacer class="my-8"></v-spacer>

              <v-img class="help-img"
                src="/static/screens/help/propriedade-index.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>


          <v-expansion-panel>
            <v-expansion-panel-header class="title">
              3. ACESSO AO ROMANEIO DE ABATE
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="subtitle-2 mb-12">
                Passo 1. Após a conclusão do cadastro da propriedade, os romaneios já podem ser visualizados na plataforma ou Clicar no Campo Romaneio para filtrar
              </p>
              
              <v-img class="help-img"
                src="/static/screens/help/home-index.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
              <p class="subtitle-2 my-12">
                Passo 2. Filtrar Romaneios para selecionar o período de dias de abate que gostaria de visualizar
              </p>
              
              <v-img class="help-img"
                src="/static/screens/help/romaneio-filtro.jpg"
                aspect-ratio="0.6"
                max-width="500"
                contain
                position="center"
              />
              <p class="subtitle-2 mb-12">
                Passo 3. Após a data selecionada, você irá encontrar a lista de lotes de abate daquele dia. No final você encontra 4 botões de ações descritos abaixo na figura
              </p>
              
              <img class="help-img"
                src="/static/screens/help/romaneio-explanation.png"
                aspect-ratio="1"
                contain
                position="left left"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>


        </v-expansion-panels>
      </v-container>

      <v-footer height="auto"
        :absolute="true"
        color="grey lighten-4"
        >
        <v-spacer></v-spacer>
        <span class="caption"> &copy; {{ new Date().getFullYear() }} Ecotrace Solutions</span>
      </v-footer>
    </v-content>

    <v-bottom-navigation
    class="hidden-md-and-up"
    :fixed="true"
    :app="true"
    color="primary"
    >
    <v-btn value="voltar" :to="{name : 'Dashboard'}">
      <span>Voltar</span>
      <v-icon color="primary">fa-angle-left</v-icon>
    </v-btn>
  </v-bottom-navigation>
  </v-app>
</template>

<script>
import Vue from 'vue'
export default {

  methods: {
    toDashBoard() {
      this.$router.push({name: 'Dashboard'})
    },

    socialLinks(linkString, targetString) {
      window.open(linkString, targetString)
    },
  },

}
</script>

<style lang="scss" scoped>
#pageHelp #itens {
  margin-bottom: 40px;
}
#pageHelp .help-img{
  margin: auto !important;
  display: block;
  max-width: 100%;
  margin: 10px 0px;
}
#pageHelp .subtitle-2 {
  margin-top: 20px;
  border-bottom: 1px solid #ccc;
  font-size: 18px !important;
}

#pageHelp::v-deep {
  #step-1 {
    .container-qrcodes-store {
      margin-bottom: 50px;

      @media screen and (max-width: 500px) {
        flex-direction: column !important;
      }

      .container-qrcode {
        @media screen and (max-width: 670px) {
          max-width: 200px;
        }

        button {
          min-height: 40px; 
        }
      }

      .container-ou {
        @media screen and (max-width: 500px) {
          margin-top: 25px;
        }
      }
    }
  }
}
</style>